import React, { FunctionComponent } from "react"
import {
    Dialog,
    DialogTitle,
    Typography,
    Grid,
    DialogContent,
    DialogActions,
    Button
} from "@material-ui/core"
import { UploadForm } from "./UploadForm"
import { LoadingButton } from "../../../components/LoadingButton"
import { useMutation } from "@apollo/client"
import { UPLOAD_AUDIO } from "../../../mutations/UPLOAD_AUDIO"
import { useNotification } from "../../../common/hooks/useNotification"
import { UploadAudioInput } from "../../../../typings/types"
import styles from "./UploadFormModal.module.scss"
interface UploadFormModalProps {
    open: boolean
    onClose: () => void
}

const UploadFormDescriptionText = () => (
    <Typography data-testid="upload-modal-description" variant="caption">
        Select an audio file to upload. Complete the required fields, then select Upload to store
        the provided audio.
    </Typography>
)

export const UploadFormModal: FunctionComponent<UploadFormModalProps> = ({ open, onClose }) => {
    const { notifySuccess } = useNotification()

    const [uploadAudio, { loading: uploadAudioLoading, error: uploadAudioError }] = useMutation(
        UPLOAD_AUDIO,
        {
            onCompleted: data => {
                notifySuccess(`Successfully uploaded file ${data.uploadAudio.fileName}`)
                onClose()
            }
        }
    )

    const handleSubmit = (formValues: UploadAudioInput) =>
        uploadAudio({ variables: { input: formValues } })

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="paper">
            <DialogTitle data-testid="upload-modal-title">Upload Audio</DialogTitle>
            <DialogContent dividers>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <UploadFormDescriptionText />
                    </Grid>
                    <Grid item>
                        <UploadForm onSubmit={handleSubmit} />
                    </Grid>
                </Grid>
            </DialogContent>
            <Grid container alignItems="center" justify="space-between">
                <Grid item className={styles.UploadFormModal__uploadError}>
                    {uploadAudioError && (
                        <Typography variant="caption" color="error" data-testid="upload-error">
                            {uploadAudioError.message}
                        </Typography>
                    )}
                </Grid>
                <Grid item className={styles.UploadFormModal__actionButtons}>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={onClose}
                            data-testid="upload-cancel-btn"
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            buttonId="upload-submit-btn"
                            text="Upload"
                            loading={uploadAudioLoading}
                            disabled={uploadAudioLoading}
                            submit
                            form="upload-audio-form"
                        />
                    </DialogActions>
                </Grid>
            </Grid>
        </Dialog>
    )
}
